import { render } from "./ViewerModal.vue?vue&type=template&id=6dfbb2cd&scoped=true&ts=true"
import script from "./ViewerModal.vue?vue&type=script&lang=ts"
export * from "./ViewerModal.vue?vue&type=script&lang=ts"

import "./ViewerModal.vue?vue&type=style&index=0&id=6dfbb2cd&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfbb2cd"]])

export default __exports__